export const TOGGELE_INQUIRY_POPUP = "TOGGELE_INQUIRY_POPUP"
export const LIST_INQUIRY_PRODUCT_REQUEST = 'LIST_INQUIRY_PRODUCT_REQUEST';
export const LIST_INQUIRY_PRODUCT_SUCCESS = 'LIST_INQUIRY_PRODUCT_SUCCESS';
export const LIST_INQUIRY_PRODUCT_FAILURE = 'LIST_INQUIRY_PRODUCT_FAILURE';
